import { render, staticRenderFns } from "./ClienteSolcitudInfo.vue?vue&type=template&id=a61cfd3e&scoped=true&"
import script from "./ClienteSolcitudInfo.vue?vue&type=script&lang=js&"
export * from "./ClienteSolcitudInfo.vue?vue&type=script&lang=js&"
import style0 from "./ClienteSolcitudInfo.vue?vue&type=style&index=0&id=a61cfd3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61cfd3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanelContent})
